import { BreakInOutDecision, BreakInOutStatus, BudgetType, CcAfe, InitiativeStage, TaType } from "../../../api/api-clientInformation";
import { InitiativeStageOptions } from "../utils/mapper-enum";

export const FilteringOperators: { [key: string]: string } = {
  'eq': 'FILTER.OPERATORS.EQUAL',
  'neq': 'FILTER.OPERATORS.NOT_EQUAL',
  'gt': 'FILTER.OPERATORS.GREATER_THAN',
  'gte': 'FILTER.OPERATORS.GREATER_THAN_OR_EQUAL',
  'lt': 'FILTER.OPERATORS.LESS_THAN',
  'lte': 'FILTER.OPERATORS.LESS_THAN_OR_EQUAL',
  'contains': 'FILTER.OPERATORS.CONTAINS',
  'starts': 'FILTER.OPERATORS.STARTS_WITH',
  'ends': 'FILTER.OPERATORS.ENDS_WITH',
  //'in': 'Consists',
  'between': 'FILTER.OPERATORS.BETWEEN',
};
export enum DataType {
  Number = 'Number',
  Text = 'Text',
  Date = 'Date',
  SelectItems = 'SelectItems'
}

export interface ColumnData {
  ColumnLabel: string;
  ColumnDataType: DataType;
  ColumnDataPath: string;
}

export interface Column {
  id: string;
  label: string;
  type: 'number' | 'text' | 'date' | 'enum' | 'datetime' | 'multiSelect';
  values?: string[];
}

export interface Operator {
  value: string;
  label: string;
}

export interface FilterItem {
  id: number;
  column: string;
  operator: string;
  value: string | string[] | Date;
  valueTo: string | Date;
}

export const initiativesColumns: Column[] = [
  { id: 'Abc', label: 'FILTER_COLUMNS.INITIATIVES.ABC', type: 'multiSelect', values: ['', 'A', 'B', 'C'] },
  { id: 'ActualStartDate', label: 'FILTER_COLUMNS.INITIATIVES.ACTUAL_START_DATE', type: 'date' },
  { id: 'ActualsYTD', label: 'FILTER_COLUMNS.INITIATIVES.ACTUALS_YTD', type: 'number' },
  { id: 'AfeNumber', label: 'FILTER_COLUMNS.INITIATIVES.AFE_NUMBER', type: 'text' },
  { id: 'AreaPriority', label: 'FILTER_COLUMNS.INITIATIVES.AREA_PRIORITY', type: 'text' },
  { id: 'AreaType', label: 'FILTER_COLUMNS.INITIATIVES.AREA', type: 'multiSelect' },
  { id: 'BudgetType', label: 'FILTER_COLUMNS.INITIATIVES.BUDGET_TYPE', type: 'enum', values: Object.values(BudgetType) },
  { id: 'CcAfe', label: 'FILTER_COLUMNS.INITIATIVES.CC_AFE', type: 'enum', values: Object.values(CcAfe) },
  { id: 'Comment', label: 'FILTER_COLUMNS.INITIATIVES.COMMENT', type: 'text' },
  { id: 'CoordinatorEmail', label: 'FILTER_COLUMNS.INITIATIVES.COORDINATOR_EMAIL', type: 'text' },
  { id: 'CoordinatorName', label: 'FILTER_COLUMNS.INITIATIVES.COORDINATOR_NAME', type: 'text' },
  { id: 'CurrentFyGrandTotal', label: 'FILTER_COLUMNS.INITIATIVES.CURRENT_FY_GRAND_TOTAL', type: 'number' },
  { id: 'Description', label: 'FILTER_COLUMNS.INITIATIVES.DESCRIPTION', type: 'text' },
  { id: 'Dpi', label: 'FILTER_COLUMNS.INITIATIVES.DPI', type: 'number' },
  { id: 'DrivingCriteria', label: 'FILTER_COLUMNS.INITIATIVES.DRIVING_CRITERIA', type: 'text' },
  { id: 'FinanceStatus', label: 'FILTER_COLUMNS.INITIATIVES.FINANCE_STATUS', type: 'enum', values: [] },
  { id: 'IsForecastUpdated', label: 'FILTER_COLUMNS.INITIATIVES.IS_FORECAST_UPDATED', type: 'enum', values: ['true', 'false'] },
  { id: 'IsForReview', label: 'FILTER_COLUMNS.INITIATIVES.IS_FOR_REVIEW', type: 'enum', values: ['true', 'false'] },
  { id: 'FyOutlook', label: 'FILTER_COLUMNS.INITIATIVES.FY_OUTLOOK_DOLLAR', type: 'number' },
  { id: 'HSERiskEfficiency', label: 'FILTER_COLUMNS.INITIATIVES.HSE_RISK_EFFICIENCY', type: 'number' },
  { id: 'Id', label: 'FILTER_COLUMNS.INITIATIVES.MEJ_ID', type: 'text' },
  { id: 'InitiatorEmail', label: 'FILTER_COLUMNS.INITIATIVES.INITIATOR_EMAIL', type: 'text' },
  { id: 'InitialInvestment', label: 'FILTER_COLUMNS.INITIATIVES.INITIAL_INVESTMENT', type: 'number' },
  { id: 'InitiativeOwnerSharedEmail', label: 'FILTER_COLUMNS.INITIATIVES.OWNER', type: 'text' },
  { id: 'InitiativeType', label: 'FILTER_COLUMNS.INITIATIVES.INITIATIVE_TYPE', type: 'text' },
  { id: 'IsCanceled', label: 'FILTER_COLUMNS.INITIATIVES.IS_CANCELED', type: 'enum', values: ['true', 'false'] },
  { id: 'LikelyConsequence', label: 'FILTER_COLUMNS.INITIATIVES.LIKELY_CONSEQUENCE', type: 'text' },
  { id: 'LikelyScenario', label: 'FILTER_COLUMNS.INITIATIVES.LIKELY_SCENARIO', type: 'text' },
  { id: 'LastFyGrandTotal', label: 'FILTER_COLUMNS.INITIATIVES.LAST_FY_GRAND_TOTAL', type: 'number' },
  { id: 'MCIProgram', label: 'FILTER_COLUMNS.INITIATIVES.MCI_PROGRAM', type: 'enum', values: [] },
  { id: 'MultiYear', label: 'FILTER_COLUMNS.INITIATIVES.MULTI_YEAR', type: 'enum', values: ['Yes', 'No'] },
  { id: 'NeedByDate', label: 'FILTER_COLUMNS.INITIATIVES.NEED_BY_DATE', type: 'date' },
  { id: 'OpportunityDescription', label: 'FILTER_COLUMNS.INITIATIVES.OPPORTUNITY_DESCRIPTION', type: 'text' },
  { id: 'OriginalBudget', label: 'FILTER_COLUMNS.INITIATIVES.ORIGINAL_BUDGET', type: 'number' },
  { id: 'PlannedEndDate', label: 'FILTER_COLUMNS.INITIATIVES.PLANNED_END_DATE', type: 'date' },
  { id: 'PlannedStartDate', label: 'FILTER_COLUMNS.INITIATIVES.PLANNED_START_DATE', type: 'date' },
  { id: 'PotentialSolution', label: 'FILTER_COLUMNS.INITIATIVES.POTENTIAL_SOLUTION', type: 'text' },
  { id: 'ProjectProgress', label: 'FILTER_COLUMNS.INITIATIVES.PROJECT_PROGRESS', type: 'number' },
  { id: 'RevisedBudget', label: 'FILTER_COLUMNS.INITIATIVES.REVISED_BUDGET', type: 'number' },
  { id: 'RevisedOutlook', label: 'FILTER_COLUMNS.INITIATIVES.REVISED_OUTLOOK', type: 'number' },
  { id: 'Ript', label: 'FILTER_COLUMNS.INITIATIVES.RIPT', type: 'number' },
  { id: 'RiptUrl', label: 'FILTER_COLUMNS.INITIATIVES.RIPT_URL', type: 'text' },
  { id: 'RiskManCategory', label: 'FILTER_COLUMNS.INITIATIVES.RISK_MANAGEMENT_CATEGORY', type: 'text' },
  { id: 'RiskManRiskScore', label: 'FILTER_COLUMNS.INITIATIVES.RISK_MANAGEMENT_SCORE', type: 'number' },
  { id: 'RiskOrAlternative', label: 'FILTER_COLUMNS.INITIATIVES.RISK_OR_ALTERNATIVE', type: 'text' },
  { id: 'Ror', label: 'FILTER_COLUMNS.INITIATIVES.ROR', type: 'number' },
  { id: 'Stage', label: 'FILTER_COLUMNS.INITIATIVES.STAGE', type: 'multiSelect', values: Object.values(InitiativeStage) },
  { id: 'TaType', label: 'FILTER_COLUMNS.INITIATIVES.TA_TYPE', type: 'enum', values: Object.values(TaType) },
  { id: 'TcoPriority', label: 'FILTER_COLUMNS.INITIATIVES.TCO_PRIORITY', type: 'text' },
  

];
export const planVsFactColumns: Column[] = [
  { id: 'Abc', label: 'FILTER_COLUMNS.PLAN_VS_FACT.ABC', type: 'multiSelect', values: ['', 'A', 'B', 'C', 'D'] },
  { id: 'ActualEndDate', label: 'FILTER_COLUMNS.PLAN_VS_FACT.ACTUAL_END_DATE', type: 'date' },
  { id: 'ActualStartDate', label: 'FILTER_COLUMNS.PLAN_VS_FACT.ACTUAL_START_DATE', type: 'date' },
  { id: 'ActualsYTD', label: 'FILTER_COLUMNS.PLAN_VS_FACT.ACTUALS_YTD', type: 'number' },
  { id: 'AfeComment', label: 'FILTER_COLUMNS.PLAN_VS_FACT.AFE_COMMENT', type: 'text' },
  { id: 'AfeEndDate', label: 'FILTER_COLUMNS.PLAN_VS_FACT.AFE_END_DATE', type: 'date' },
  { id: 'AfeNumber', label: 'FILTER_COLUMNS.PLAN_VS_FACT.AFE', type: 'text' },
  { id: 'AfeStartDate', label: 'FILTER_COLUMNS.PLAN_VS_FACT.AFE_START_DATE', type: 'date' },
  { id: 'AreaPriority', label: 'FILTER_COLUMNS.PLAN_VS_FACT.AREA_PRIORITY', type: 'text' },
  { id: 'AreaPriority', label: 'FILTER_COLUMNS.PLAN_VS_FACT.AREA_PRIORITY_ENUM', type: 'enum', values: [1, 2, 3].map(String) },
  { id: 'BudgetType', label: 'FILTER_COLUMNS.PLAN_VS_FACT.BUDGET_TYPE', type: 'enum', values: Object.values(BudgetType) },
  { id: 'CcAfe', label: 'FILTER_COLUMNS.PLAN_VS_FACT.CC_AFE', type: 'enum', values: Object.values(CcAfe) },
  { id: 'Comment', label: 'FILTER_COLUMNS.PLAN_VS_FACT.COMMENT', type: 'text' },
  { id: 'Description', label: 'FILTER_COLUMNS.PLAN_VS_FACT.DESCRIPTION', type: 'text' },
  { id: 'Dpi', label: 'FILTER_COLUMNS.PLAN_VS_FACT.DPI', type: 'number' },
  { id: 'DrivingCriteria', label: 'FILTER_COLUMNS.PLAN_VS_FACT.DRIVING_CRITERIA', type: 'text' },
  { id: 'FinanceStatus', label: 'FILTER_COLUMNS.PLAN_VS_FACT.FINANCE_STATUS', type: 'enum', values: [] },
  { id: 'IsForecastUpdated', label: 'FILTER_COLUMNS.PLAN_VS_FACT.IS_FORECAST_UPDATED', type: 'enum', values: ['true', 'false'] },
  { id: 'IsForReview', label: 'FILTER_COLUMNS.PLAN_VS_FACT.IS_FOR_REVIEW', type: 'enum', values: ['true', 'false'] },
  { id: 'FyOutlook', label: 'FILTER_COLUMNS.PLAN_VS_FACT.FY_OUTLOOK_DOLLAR', type: 'number' },
  { id: 'HSERiskEfficiency', label: 'FILTER_COLUMNS.PLAN_VS_FACT.HSE_RISK_EFFICIENCY', type: 'number' },
  { id: 'Id', label: 'FILTER_COLUMNS.PLAN_VS_FACT.MEJ_ID', type: 'text' },
  { id: 'InitiatorEmail', label: 'FILTER_COLUMNS.PLAN_VS_FACT.INITIATOR_EMAIL', type: 'text' },
  { id: 'InitialInvestment', label: 'FILTER_COLUMNS.PLAN_VS_FACT.INITIAL_INVESTMENT', type: 'number' },
  { id: 'InitiativeOwnerSharedEmail', label: 'FILTER_COLUMNS.PLAN_VS_FACT.OWNER', type: 'text' },
  { id: 'InitiativeType', label: 'FILTER_COLUMNS.PLAN_VS_FACT.INITIATIVE_TYPE', type: 'text' },
  { id: 'IsCanceled', label: 'FILTER_COLUMNS.PLAN_VS_FACT.IS_CANCELED', type: 'enum', values: ['true', 'false'] },
  { id: 'LikelyConsequence', label: 'FILTER_COLUMNS.PLAN_VS_FACT.LIKELY_CONSEQUENCE', type: 'text' },
  { id: 'LikelyScenario', label: 'FILTER_COLUMNS.PLAN_VS_FACT.LIKELY_SCENARIO', type: 'text' },
  { id: 'MCIProgram', label: 'FILTER_COLUMNS.PLAN_VS_FACT.MCI_PROGRAM', type: 'enum', values: [] },
  { id: 'MultiYear', label: 'FILTER_COLUMNS.PLAN_VS_FACT.MULTI_YEAR', type: 'enum', values: ['Yes', 'No'] },
  { id: 'NeedByDate', label: 'FILTER_COLUMNS.PLAN_VS_FACT.NEED_BY_DATE', type: 'date' },
  { id: 'OpportunityDescription', label: 'FILTER_COLUMNS.PLAN_VS_FACT.OPPORTUNITY_DESCRIPTION', type: 'text' },
  { id: 'OriginalBudget', label: 'FILTER_COLUMNS.PLAN_VS_FACT.ORIGINAL_BUDGET', type: 'number' },
  { id: 'PlannedEndDate', label: 'FILTER_COLUMNS.PLAN_VS_FACT.PLANNED_END_DATE', type: 'date' },
  { id: 'PlannedStartDate', label: 'FILTER_COLUMNS.PLAN_VS_FACT.PLANNED_START_DATE', type: 'date' },
  { id: 'PotentialSolution', label: 'FILTER_COLUMNS.PLAN_VS_FACT.POTENTIAL_SOLUTION', type: 'text' },
  { id: 'ProjectOwnerEmail', label: 'FILTER_COLUMNS.PLAN_VS_FACT.PROJECT_OWNER', type: 'text' },
  { id: 'ProjectProgress', label: 'FILTER_COLUMNS.PLAN_VS_FACT.PROJECT_PROGRESS', type: 'number' },
  { id: 'RevisedBudget', label: 'FILTER_COLUMNS.PLAN_VS_FACT.REVISED_BUDGET', type: 'number' },
  { id: 'RevisedOutlook', label: 'FILTER_COLUMNS.PLAN_VS_FACT.REVISED_OUTLOOK', type: 'number' },
  { id: 'Ript', label: 'FILTER_COLUMNS.PLAN_VS_FACT.RIPT', type: 'number' },
  { id: 'RiptUrl', label: 'FILTER_COLUMNS.PLAN_VS_FACT.RIPT_URL', type: 'text' },
  { id: 'RiskManCategory', label: 'FILTER_COLUMNS.PLAN_VS_FACT.RISK_MANAGEMENT_CATEGORY', type: 'text' },
  { id: 'RiskManRiskScore', label: 'FILTER_COLUMNS.PLAN_VS_FACT.RISK_MANAGEMENT_SCORE', type: 'number' },
  { id: 'RiskOrAlternative', label: 'FILTER_COLUMNS.PLAN_VS_FACT.RISK_OR_ALTERNATIVE', type: 'text' },
  { id: 'Ror', label: 'FILTER_COLUMNS.PLAN_VS_FACT.ROR', type: 'number' },
  { id: 'Stage', label: 'FILTER_COLUMNS.PLAN_VS_FACT.STAGE', type: 'multiSelect', values: Object.values(InitiativeStage) },
  { id: 'TaType', label: 'FILTER_COLUMNS.PLAN_VS_FACT.TA_TYPE', type: 'enum', values: Object.values(TaType) },
  { id: 'TcoPriority', label: 'FILTER_COLUMNS.PLAN_VS_FACT.TCO_PRIORITY', type: 'text' },
  { id: 'TcoPriority', label: 'FILTER_COLUMNS.PLAN_VS_FACT.TCO_PRIORITY_ENUM', type: 'enum', values: [1, 2, 3].map(String) },
];
export const forecastColumns: Column[] = [
  { id: 'Abc', label: 'FILTER_COLUMNS.FORECAST.ABC', type: 'text' },
  { id: 'ActualEndDate', label: 'FILTER_COLUMNS.FORECAST.ACTUAL_END_DATE', type: 'date' },
  { id: 'ActualStartDate', label: 'FILTER_COLUMNS.FORECAST.ACTUAL_START_DATE', type: 'date' },
  { id: 'ActualsYTD', label: 'FILTER_COLUMNS.FORECAST.ACTUALS_YTD', type: 'number' },
  { id: 'AfeAmount', label: 'FILTER_COLUMNS.FORECAST.AFE_AMOUNT', type: 'number' },
  { id: 'AfeComment', label: 'FILTER_COLUMNS.FORECAST.AFE_COMMENT', type: 'text' },
  { id: 'AfeEndDate', label: 'FILTER_COLUMNS.FORECAST.AFE_END_DATE', type: 'date' },
  { id: 'AfeNumber', label: 'FILTER_COLUMNS.FORECAST.AFE_NUMBER', type: 'text' },
  { id: 'AfeStartDate', label: 'FILTER_COLUMNS.FORECAST.AFE_START_DATE', type: 'date' },
  { id: 'ApprovedBudget', label: 'FILTER_COLUMNS.FORECAST.APPROVED_BUDGET', type: 'number' },
  { id: 'AreaPriority', label: 'FILTER_COLUMNS.FORECAST.AREA_PRIORITY', type: 'text' },
  { id: 'BreakInOutJustification', label: 'FILTER_COLUMNS.FORECAST.BREAK_IN_OUT_JUSTIFICATION', type: 'text' },
  { id: 'BudgetType', label: 'FILTER_COLUMNS.FORECAST.BUDGET_TYPE', type: 'enum', values: Object.values(BudgetType) },
  { id: 'CcAfe', label: 'FILTER_COLUMNS.FORECAST.CC_AFE', type: 'enum', values: Object.values(CcAfe) },
  { id: 'Comment', label: 'FILTER_COLUMNS.FORECAST.COMMENT', type: 'text' },
  { id: 'CostController', label: 'FILTER_COLUMNS.FORECAST.COST_CONTROLLER', type: 'text' },
  { id: 'Description', label: 'FILTER_COLUMNS.FORECAST.DESCRIPTION', type: 'text' },
  { id: 'Dpi', label: 'FILTER_COLUMNS.FORECAST.DPI', type: 'number' },
  { id: 'DrivingCriteria', label: 'FILTER_COLUMNS.FORECAST.DRIVING_CRITERIA', type: 'text' },
  { id: 'FinanceStatus', label: 'FILTER_COLUMNS.FORECAST.FINANCE_STATUS', type: 'enum', values: [] },
  { id: 'IsForecastUpdated', label: 'FILTER_COLUMNS.FORECAST.IS_FORECAST_UPDATED', type: 'enum', values: ['true', 'false'] },
  { id: 'IsForReview', label: 'FILTER_COLUMNS.FORECAST.IS_FOR_REVIEW', type: 'enum', values: ['true', 'false'] },
  { id: 'FyOutlook', label: 'FILTER_COLUMNS.FORECAST.FY_OUTLOOK', type: 'number' },
  { id: 'HseRiskEfficiency', label: 'FILTER_COLUMNS.FORECAST.HSE_RISK_EFFICIENCY', type: 'number' },
  { id: 'Id', label: 'FILTER_COLUMNS.FORECAST.MEJ_ID', type: 'text' }, 
  { id: 'InitiatorEmail', label: 'FILTER_COLUMNS.FORECAST.INITIATOR_EMAIL', type: 'text' },
  { id: 'InitialInvestment', label: 'FILTER_COLUMNS.FORECAST.INITIAL_INVESTMENT', type: 'number' },
  { id: 'InitiativeOwnerSharedEmail', label: 'FILTER_COLUMNS.FORECAST.OWNER', type: 'text' },
  { id: 'InitiativeType', label: 'FILTER_COLUMNS.FORECAST.INITIATIVE_TYPE', type: 'text' },
  { id: 'LikelyConsequence', label: 'FILTER_COLUMNS.FORECAST.LIKELY_CONSEQUENCE', type: 'text' },
  { id: 'LikelyScenario', label: 'FILTER_COLUMNS.FORECAST.LIKELY_SCENARIO', type: 'text' },
  { id: 'MCIProgram', label: 'FILTER_COLUMNS.FORECAST.MCI_PROGRAM', type: 'enum', values: [] },
  { id: 'MultiYear', label: 'FILTER_COLUMNS.FORECAST.MULTI_YEAR', type: 'enum', values: ['Yes', 'No'] },
  { id: 'NeedByDate', label: 'FILTER_COLUMNS.FORECAST.NEED_BY_DATE', type: 'date' },
  { id: 'OpportunityDescription', label: 'FILTER_COLUMNS.FORECAST.OPPORTUNITY_DESCRIPTION', type: 'text' },
  { id: 'OriginalBudget', label: 'FILTER_COLUMNS.FORECAST.ORIGINAL_BUDGET', type: 'number' },
  { id: 'PlannedEndDate', label: 'FILTER_COLUMNS.FORECAST.PLANNED_END_DATE', type: 'date' },
  { id: 'PlannedStartDate', label: 'FILTER_COLUMNS.FORECAST.PLANNED_START_DATE', type: 'date' },
  { id: 'PotentialSolution', label: 'FILTER_COLUMNS.FORECAST.POTENTIAL_SOLUTION', type: 'text' },
  { id: 'ProjectProgress', label: 'FILTER_COLUMNS.FORECAST.PROJECT_PROGRESS', type: 'number' },
  { id: 'RevisedBudget', label: 'FILTER_COLUMNS.FORECAST.REVISED_BUDGET', type: 'number' },
  { id: 'RevisedOutlook', label: 'FILTER_COLUMNS.FORECAST.REVISED_OUTLOOK', type: 'number' },
  { id: 'Ript', label: 'FILTER_COLUMNS.FORECAST.RIPT', type: 'number' },
  { id: 'RiptUrl', label: 'FILTER_COLUMNS.FORECAST.RIPT_URL', type: 'text' },
  { id: 'RiskManCategory', label: 'FILTER_COLUMNS.FORECAST.RISK_MAN_CATEGORY', type: 'text' },
  { id: 'RiskManRiskScore', label: 'FILTER_COLUMNS.FORECAST.RISK_MAN_RISK_SCORE', type: 'number' },
  { id: 'RiskOrAlternative', label: 'FILTER_COLUMNS.FORECAST.RISK_OR_ALTERNATIVE', type: 'text' },
  { id: 'Ror', label: 'FILTER_COLUMNS.FORECAST.ROR', type: 'number' },
  { id: 'Stage', label: 'FILTER_COLUMNS.FORECAST.STAGE', type: 'multiSelect', values: Object.values(InitiativeStage) },
  { id: 'TaType', label: 'FILTER_COLUMNS.FORECAST.TA_TYPE', type: 'enum', values: Object.values(TaType) },
  { id: 'TcoPriority', label: 'FILTER_COLUMNS.FORECAST.TCO_PRIORITY', type: 'text' },
 
];

export const myApprovalsColumns: Column[] = [
  { id: 'Abc', label: 'FILTER_COLUMNS.APPROVALS.ABC', type: 'multiSelect', values: ['', 'A', 'B', 'C'] },
  { id: 'AreaType', label: 'FILTER_COLUMNS.APPROVALS.AREA', type: 'multiSelect' },
  { id: 'Comment', label: 'FILTER_COLUMNS.APPROVALS.COMMENT', type: 'text' },
  { id: 'Description', label: 'FILTER_COLUMNS.APPROVALS.DESCRIPTION', type: 'text' },
  { id: 'InitiativeType', label: 'FILTER_COLUMNS.APPROVALS.INITIATIVE_TYPE', type: 'text' },
  { id: 'InitiativeOwnerSharedEmail', label: 'FILTER_COLUMNS.APPROVALS.OWNER', type: 'text' },
  { id: 'FyOutlook', label: 'FILTER_COLUMNS.APPROVALS.FY_OUTLOOK_DOLLAR', type: 'number' },
  { id: 'NeedByDate', label: 'FILTER_COLUMNS.APPROVALS.NEED_BY_DATE', type: 'date' },
  { id: 'RevisedBudget', label: 'FILTER_COLUMNS.APPROVALS.REVISED_BUDGET', type: 'number' },
  { id: 'Ript', label: 'FILTER_COLUMNS.APPROVALS.RIPT', type: 'number' },
  { id: 'Stage', label: 'FILTER_COLUMNS.APPROVALS.STAGE', type: 'multiSelect', values: Object.values(InitiativeStage) },
];
export const mejCutlineColumns: Column[] = [
  { id: 'Abc', label: 'FILTER_COLUMNS.MEJ_CUTLINE.ABC', type: 'multiSelect', values: ['', 'A', 'B', 'C'] },
  { id: 'ActualStartDate', label: 'FILTER_COLUMNS.MEJ_CUTLINE.ACTUAL_START_DATE', type: 'date' },
  { id: 'ActualsYTD', label: 'FILTER_COLUMNS.MEJ_CUTLINE.ACTUALS_YTD', type: 'number' },
  { id: 'AfeNumber', label: 'FILTER_COLUMNS.MEJ_CUTLINE.AFE_NUMBER', type: 'text' },
  { id: 'Area', label: 'FILTER_COLUMNS.MEJ_CUTLINE.AREA', type: 'multiSelect' },
  { id: 'AreaPriority', label: 'FILTER_COLUMNS.MEJ_CUTLINE.AREA_PRIORITY', type: 'text' },
  { id: 'AreaType', label: 'FILTER_COLUMNS.MEJ_CUTLINE.AREA_TYPE', type: 'enum', values: [] },
  { id: 'BudgetType', label: 'FILTER_COLUMNS.MEJ_CUTLINE.BUDGET_TYPE', type: 'enum', values: Object.values(BudgetType) },
  { id: 'CcAfe', label: 'FILTER_COLUMNS.MEJ_CUTLINE.CC_AFE', type: 'enum', values: Object.values(CcAfe) },
  { id: 'Comment', label: 'FILTER_COLUMNS.MEJ_CUTLINE.COMMENT', type: 'text' },
  { id: 'Description', label: 'FILTER_COLUMNS.MEJ_CUTLINE.DESCRIPTION', type: 'text' },
  { id: 'Dpi', label: 'FILTER_COLUMNS.MEJ_CUTLINE.DPI', type: 'number' },
  { id: 'DrivingCriteria', label: 'FILTER_COLUMNS.MEJ_CUTLINE.DRIVING_CRITERIA', type: 'text' },
  { id: 'IsForecastUpdated', label: 'FILTER_COLUMNS.MEJ_CUTLINE.IS_FORECAST_UPDATED', type: 'enum', values: ['true', 'false'] },
  { id: 'IsForReview', label: 'FILTER_COLUMNS.MEJ_CUTLINE.IS_FOR_REVIEW', type: 'enum', values: ['true', 'false'] },
  { id: 'FinanceStatus', label: 'FILTER_COLUMNS.MEJ_CUTLINE.FINANCE_STATUS', type: 'enum', values: [] },
  { id: 'Fy1', label: 'FILTER_COLUMNS.MEJ_CUTLINE.FY1', type: 'number' },
  { id: 'Fy2', label: 'FILTER_COLUMNS.MEJ_CUTLINE.FY2', type: 'number' },
  { id: 'Fy3', label: 'FILTER_COLUMNS.MEJ_CUTLINE.FY3', type: 'number' },
  { id: 'FyOutlook', label: 'FILTER_COLUMNS.MEJ_CUTLINE.FY_OUTLOOK_DOLLAR', type: 'number' },
  { id: 'HSERiskEfficiency', label: 'FILTER_COLUMNS.MEJ_CUTLINE.HSE_RISK_EFFICIENCY', type: 'number' },
  { id: 'Id', label: 'FILTER_COLUMNS.MEJ_CUTLINE.MEJ_ID', type: 'text' },
  { id: 'InitiatorEmail', label: 'FILTER_COLUMNS.MEJ_CUTLINE.INITIATOR_EMAIL', type: 'text' },
  { id: 'InitialInvestment', label: 'FILTER_COLUMNS.MEJ_CUTLINE.INITIAL_INVESTMENT', type: 'number' },
  { id: 'InitiativeOwnerSharedEmail', label: 'FILTER_COLUMNS.MEJ_CUTLINE.OWNER', type: 'text' },
  { id: 'InitiativeType', label: 'FILTER_COLUMNS.MEJ_CUTLINE.INITIATIVE_TYPE', type: 'date' },
  { id: 'IsCanceled', label: 'FILTER_COLUMNS.MEJ_CUTLINE.IS_CANCELED', type: 'enum', values: ['true', 'false'] },
  { id: 'IsIn', label: 'FILTER_COLUMNS.MEJ_CUTLINE.CUTLINE', type: 'text' },
  { id: 'LeftoverAtCut', label: 'FILTER_COLUMNS.MEJ_CUTLINE.LEFTOVER_AT_CUT', type: 'text' },
  { id: 'LikelyConsequence', label: 'FILTER_COLUMNS.MEJ_CUTLINE.LIKELY_CONSEQUENCE', type: 'text' },
  { id: 'LikelyScenario', label: 'FILTER_COLUMNS.MEJ_CUTLINE.LIKELY_SCENARIO', type: 'text' },
  { id: 'MCIProgram', label: 'FILTER_COLUMNS.MEJ_CUTLINE.MCI_PROGRAM', type: 'enum', values: [] },
  { id: 'MultiYear', label: 'FILTER_COLUMNS.MEJ_CUTLINE.MULTI_YEAR', type: 'enum', values: ['Yes', 'No'] },
  { id: 'NeedByDate', label: 'FILTER_COLUMNS.MEJ_CUTLINE.NEED_BY_DATE', type: 'date' },
  { id: 'OpportunityDescription', label: 'FILTER_COLUMNS.MEJ_CUTLINE.OPPORTUNITY_DESCRIPTION', type: 'text' },
  { id: 'OrderIndex', label: 'FILTER_COLUMNS.MEJ_CUTLINE.ORDER_INDEX', type: 'text' },
  { id: 'OriginalBudget', label: 'FILTER_COLUMNS.MEJ_CUTLINE.ORIGINAL_BUDGET', type: 'number' },
  { id: 'PlannedEndDate', label: 'FILTER_COLUMNS.MEJ_CUTLINE.PLANNED_END_DATE', type: 'date' },
  { id: 'PlannedStartDate', label: 'FILTER_COLUMNS.MEJ_CUTLINE.PLANNED_START_DATE', type: 'date' },
  { id: 'PotentialSolution', label: 'FILTER_COLUMNS.MEJ_CUTLINE.POTENTIAL_SOLUTION', type: 'text' },
  { id: 'ProjectProgress', label: 'FILTER_COLUMNS.MEJ_CUTLINE.PROJECT_PROGRESS', type: 'number' },
  { id: 'ProjectTotalCost', label: 'FILTER_COLUMNS.MEJ_CUTLINE.PROJECT_TOTAL_COST', type: 'number' },
  { id: 'RevisedBudget', label: 'FILTER_COLUMNS.MEJ_CUTLINE.REVISED_BUDGET', type: 'number' },
  { id: 'Ript', label: 'FILTER_COLUMNS.MEJ_CUTLINE.RIPT', type: 'number' },
  { id: 'RiptUrl', label: 'FILTER_COLUMNS.MEJ_CUTLINE.RIPT_URL', type: 'text' },
  { id: 'RiskManCategory', label: 'FILTER_COLUMNS.MEJ_CUTLINE.RISK_MANAGEMENT_CATEGORY', type: 'text' },
  { id: 'RiskManRiskScore', label: 'FILTER_COLUMNS.MEJ_CUTLINE.RISK_MANAGEMENT_SCORE', type: 'number' },
  { id: 'RiskOrAlternative', label: 'FILTER_COLUMNS.MEJ_CUTLINE.RISK_OR_ALTERNATIVE', type: 'text' },
  { id: 'Ror', label: 'FILTER_COLUMNS.MEJ_CUTLINE.ROR', type: 'number' },
  { id: 'Stage', label: 'FILTER_COLUMNS.MEJ_CUTLINE.STAGE', type: 'multiSelect', values: Object.values(InitiativeStage) },
  // { id: 'StageEnum', label: 'FILTER_COLUMNS.MEJ_CUTLINE.STAGE_ENUM', type: 'text' },
  { id: 'SumOfBudget', label: 'FILTER_COLUMNS.MEJ_CUTLINE.SUM_OF_CURRENT_OUTLOOK', type: 'number' },
  { id: 'TaType', label: 'FILTER_COLUMNS.MEJ_CUTLINE.TA_TYPE', type: 'enum', values: Object.values(TaType) },
  { id: 'TcoPriority', label: 'FILTER_COLUMNS.MEJ_CUTLINE.TCO_PRIORITY', type: 'text' },
  
];

export const breakInOutColumns: Column[] = [
  { id: 'AreaType', label: 'FILTER_COLUMNS.BREAK_IN_OUT.AREA', type: 'multiSelect' },
  { id: 'CreatedOn', label: 'FILTER_COLUMNS.BREAK_IN_OUT.CREATED_ON', type: 'datetime' },
  { id: 'Decision', label: 'FILTER_COLUMNS.BREAK_IN_OUT.DECISION', type: 'enum', values: Object.values(BreakInOutDecision) },
  { id: 'DecisionComment', label: 'FILTER_COLUMNS.BREAK_IN_OUT.DECISION_COMMENT', type: 'text' },
  { id: 'Delta', label: 'FILTER_COLUMNS.BREAK_IN_OUT.BIO_AMOUNT', type: 'number' },
  { id: 'Description', label: 'FILTER_COLUMNS.BREAK_IN_OUT.DESCRIPTION', type: 'text' },
  { id: 'InitiativeOwnerSharedEmail', label: 'FILTER_COLUMNS.BREAK_IN_OUT.INITIATIVE_OWNER', type: 'text' },
  { id: 'Justification', label: 'FILTER_COLUMNS.BREAK_IN_OUT.JUSTIFICATION', type: 'text' },
  { id: 'OriginalOutlook', label: 'FILTER_COLUMNS.BREAK_IN_OUT.ORIGINAL_OUTLOOK', type: 'number' },
  { id: 'RevisedOutlook', label: 'FILTER_COLUMNS.BREAK_IN_OUT.REVISED_OUTLOOK', type: 'number' },
  { id: 'Ript', label: 'FILTER_COLUMNS.BREAK_IN_OUT.RIPT', type: 'number' },
  { id: 'Status', label: 'FILTER_COLUMNS.BREAK_IN_OUT.STATUS', type: 'enum', values: Object.values(BreakInOutStatus) },
  { id: 'StatusComment', label: 'FILTER_COLUMNS.BREAK_IN_OUT.STATUS_COMMENT', type: 'text' },
];


export const allOperators: Record<string, Operator[]> = {
  number: [
    { value: 'eq', label: 'FILTER.OPERATORS.EQUALS' },
    { value: 'neq', label: 'FILTER.OPERATORS.NOT_EQUALS' },
    { value: 'gt', label: 'FILTER.OPERATORS.GREATER_THAN' },
    { value: 'lt', label: 'FILTER.OPERATORS.LESS_THAN' },
    { value: 'gte', label: 'FILTER.OPERATORS.GREATER_OR_EQUAL' },
    { value: 'lte', label: 'FILTER.OPERATORS.LESS_OR_EQUAL' },
  ],
  text: [
    { value: 'eq', label: 'FILTER.OPERATORS.EQUALS' },
    { value: 'neq', label: 'FILTER.OPERATORS.NOT_EQUALS' },
    { value: 'contains', label: 'FILTER.OPERATORS.CONTAINS' },
    { value: 'starts', label: 'FILTER.OPERATORS.STARTS_WITH' },
    { value: 'ends', label: 'FILTER.OPERATORS.ENDS_WITH' },
  ],
  date: [
    { value: 'eq', label: 'FILTER.OPERATORS.EQUALS' },
    { value: 'gt', label: 'FILTER.OPERATORS.GREATER_THAN' },
    { value: 'lt', label: 'FILTER.OPERATORS.LESS_THAN' },
    { value: 'between', label: 'FILTER.OPERATORS.BETWEEN' },
  ],
  enum: [
    { value: 'eq', label: 'FILTER.OPERATORS.EQUALS' },
    { value: 'neq', label: 'FILTER.OPERATORS.NOT_EQUALS' },
  ],
  datetime: [
    { value: 'gt', label: 'FILTER.OPERATORS.GREATER_THAN' },
    { value: 'lt', label: 'FILTER.OPERATORS.LESS_THAN' },
    { value: 'between', label: 'FILTER.OPERATORS.BETWEEN' },
  ],
  multiSelect: [
    { value: 'in', label: 'FILTER.OPERATORS.EQUALS' }
  ]
};

export const linkedRecordsColumns: Column[] = [
  { id: 'type', label: 'FILTER_COLUMNS.LINKED_RECORDS.TYPE', type: 'enum', values: ['BA', 'EWR', 'ITR', 'IDR', 'RTR', 'RDR', 'TDR', 'AR'] },
];

/** Filter columns for the Gantt Chart view – mirrors the same fields available in the report-list (initiatives) view. */
export const ganttChartColumns: Column[] = [
  { id: 'Abc', label: 'FILTER_COLUMNS.INITIATIVES.ABC', type: 'multiSelect', values: ['', 'A', 'B', 'C'] },
  { id: 'ActualStartDate', label: 'FILTER_COLUMNS.INITIATIVES.ACTUAL_START_DATE', type: 'date' },
  { id: 'ActualsYTD', label: 'FILTER_COLUMNS.INITIATIVES.ACTUALS_YTD', type: 'number' },
  { id: 'AfeNumber', label: 'FILTER_COLUMNS.INITIATIVES.AFE_NUMBER', type: 'text' },
  { id: 'AreaPriority', label: 'FILTER_COLUMNS.INITIATIVES.AREA_PRIORITY', type: 'text' },
  { id: 'AreaType', label: 'FILTER_COLUMNS.INITIATIVES.AREA', type: 'multiSelect' },
  { id: 'BudgetType', label: 'FILTER_COLUMNS.INITIATIVES.BUDGET_TYPE', type: 'enum', values: Object.values(BudgetType) },
  { id: 'CcAfe', label: 'FILTER_COLUMNS.INITIATIVES.CC_AFE', type: 'enum', values: Object.values(CcAfe) },
  { id: 'Comment', label: 'FILTER_COLUMNS.INITIATIVES.COMMENT', type: 'text' },
  { id: 'CoordinatorEmail', label: 'FILTER_COLUMNS.INITIATIVES.COORDINATOR_EMAIL', type: 'text' },
  { id: 'CoordinatorName', label: 'FILTER_COLUMNS.INITIATIVES.COORDINATOR_NAME', type: 'text' },
  { id: 'Description', label: 'FILTER_COLUMNS.INITIATIVES.DESCRIPTION', type: 'text' },
  { id: 'Dpi', label: 'FILTER_COLUMNS.INITIATIVES.DPI', type: 'number' },
  { id: 'DrivingCriteria', label: 'FILTER_COLUMNS.INITIATIVES.DRIVING_CRITERIA', type: 'text' },
  { id: 'FinanceStatus', label: 'FILTER_COLUMNS.INITIATIVES.FINANCE_STATUS', type: 'enum', values: [] },
  { id: 'IsForecastUpdated', label: 'FILTER_COLUMNS.INITIATIVES.IS_FORECAST_UPDATED', type: 'enum', values: ['true', 'false'] },
  { id: 'IsForReview', label: 'FILTER_COLUMNS.INITIATIVES.IS_FOR_REVIEW', type: 'enum', values: ['true', 'false'] },
  { id: 'FyOutlook', label: 'FILTER_COLUMNS.INITIATIVES.FY_OUTLOOK_DOLLAR', type: 'number' },
  { id: 'HSERiskEfficiency', label: 'FILTER_COLUMNS.INITIATIVES.HSE_RISK_EFFICIENCY', type: 'number' },
  { id: 'Id', label: 'FILTER_COLUMNS.INITIATIVES.MEJ_ID', type: 'text' },
  { id: 'InitiatorEmail', label: 'FILTER_COLUMNS.INITIATIVES.INITIATOR_EMAIL', type: 'text' },
  { id: 'InitialInvestment', label: 'FILTER_COLUMNS.INITIATIVES.INITIAL_INVESTMENT', type: 'number' },
  { id: 'InitiativeOwnerSharedEmail', label: 'FILTER_COLUMNS.INITIATIVES.OWNER', type: 'text' },
  { id: 'InitiativeType', label: 'FILTER_COLUMNS.INITIATIVES.INITIATIVE_TYPE', type: 'text' },
  { id: 'IsCanceled', label: 'FILTER_COLUMNS.INITIATIVES.IS_CANCELED', type: 'enum', values: ['true', 'false'] },
  { id: 'LikelyConsequence', label: 'FILTER_COLUMNS.INITIATIVES.LIKELY_CONSEQUENCE', type: 'text' },
  { id: 'LikelyScenario', label: 'FILTER_COLUMNS.INITIATIVES.LIKELY_SCENARIO', type: 'text' },
  { id: 'MCIProgram', label: 'FILTER_COLUMNS.INITIATIVES.MCI_PROGRAM', type: 'enum', values: [] },
  { id: 'MultiYear', label: 'FILTER_COLUMNS.INITIATIVES.MULTI_YEAR', type: 'enum', values: ['Yes', 'No'] },
  { id: 'NeedByDate', label: 'FILTER_COLUMNS.INITIATIVES.NEED_BY_DATE', type: 'date' },
  { id: 'OpportunityDescription', label: 'FILTER_COLUMNS.INITIATIVES.OPPORTUNITY_DESCRIPTION', type: 'text' },
  { id: 'OriginalBudget', label: 'FILTER_COLUMNS.INITIATIVES.ORIGINAL_BUDGET', type: 'number' },
  { id: 'PlannedEndDate', label: 'FILTER_COLUMNS.INITIATIVES.PLANNED_END_DATE', type: 'date' },
  { id: 'PlannedStartDate', label: 'FILTER_COLUMNS.INITIATIVES.PLANNED_START_DATE', type: 'date' },
  { id: 'PotentialSolution', label: 'FILTER_COLUMNS.INITIATIVES.POTENTIAL_SOLUTION', type: 'text' },
  { id: 'ProjectProgress', label: 'FILTER_COLUMNS.INITIATIVES.PROJECT_PROGRESS', type: 'number' },
  { id: 'RevisedBudget', label: 'FILTER_COLUMNS.INITIATIVES.REVISED_BUDGET', type: 'number' },
  { id: 'RevisedOutlook', label: 'FILTER_COLUMNS.INITIATIVES.REVISED_OUTLOOK', type: 'number' },
  { id: 'Ript', label: 'FILTER_COLUMNS.INITIATIVES.RIPT', type: 'number' },
  { id: 'RiptUrl', label: 'FILTER_COLUMNS.INITIATIVES.RIPT_URL', type: 'text' },
  { id: 'RiskManCategory', label: 'FILTER_COLUMNS.INITIATIVES.RISK_MANAGEMENT_CATEGORY', type: 'text' },
  { id: 'RiskManRiskScore', label: 'FILTER_COLUMNS.INITIATIVES.RISK_MANAGEMENT_SCORE', type: 'number' },
  { id: 'RiskOrAlternative', label: 'FILTER_COLUMNS.INITIATIVES.RISK_OR_ALTERNATIVE', type: 'text' },
  { id: 'Ror', label: 'FILTER_COLUMNS.INITIATIVES.ROR', type: 'number' },
  // { id: 'Stage', label: 'FILTER_COLUMNS.INITIATIVES.STAGE', type: 'enum', values: Object.values(InitiativeStage) },
  { id: 'Stage', label: 'FILTER_COLUMNS.INITIATIVES.STAGE', type: 'multiSelect', values: Object.values(InitiativeStage) },
  { id: 'TaType', label: 'FILTER_COLUMNS.INITIATIVES.TA_TYPE', type: 'enum', values: Object.values(TaType) },
  { id: 'TcoPriority', label: 'FILTER_COLUMNS.INITIATIVES.TCO_PRIORITY', type: 'text' },
  { id: 'Year', label: 'FILTER_COLUMNS.INITIATIVES.YEAR', type: 'number' },
  

];
